// Module
var code = "<div ng-if=\"$ctrl.model.idNature\" ng-include=\"$ctrl.templateUrl\"></div> ";
// Exports
module.exports = code;